import { createClient } from '@supabase/supabase-js';

// Verifiserte verdier for dette prosjektet
const SUPABASE_URL = 'https://pqfvobpqlotkmpkowbpl.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBxZnZvYnBxbG90a21wa293YnBsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkwMTA0MjcsImV4cCI6MjA4NDU4NjQyN30.LYas5j8wtDKDr19_TJNnu0N9lcyG1UN-M5MLNq0z3bM';

console.log('[SUPABASE CONFIG] Initializing client for:', SUPABASE_URL);

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

export default supabase;